import { render, staticRenderFns } from "./scoringCheck.vue?vue&type=template&id=738bc365&scoped=true"
import script from "./scoringCheck.vue?vue&type=script&lang=js"
export * from "./scoringCheck.vue?vue&type=script&lang=js"
import style0 from "./scoringCheck.vue?vue&type=style&index=0&id=738bc365&prod&lang=scss&scoped=true&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738bc365",
  null
  
)

export default component.exports